import { useEffect, useState } from 'react';

import { useViewportSize } from '@eika/hooks';

interface ReturnType {
    isKeyboardVisible: boolean;
    fullViewportHeight: number;
    viewportHeight: number;
    keyboardHeight: number;
}

const useDetectKeyboard = (): ReturnType => {
    const [fullViewportHeight, setFullViewportHeight] = useState(window.innerHeight);
    const [, viewportHeight] = useViewportSize();

    useEffect(() => {
        if (fullViewportHeight < viewportHeight) {
            setFullViewportHeight(viewportHeight);
        }
    }, [fullViewportHeight, viewportHeight]);

    const height = window.visualViewport?.height ?? 0;
    const keyboardHeight = fullViewportHeight - height;
    const isKeyboardVisible = keyboardHeight > 0;
    return { isKeyboardVisible, fullViewportHeight, viewportHeight, keyboardHeight };
};

export default useDetectKeyboard;
